/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';

export default class PreEnrolmentsController extends Controller {
  // Services
  @service
  store;

  @tracked sortProp = 'person.firstName';
  @tracked sortDir = 'asc';

  @computed('model.[]', 'sortProp', 'sortDir')
  get preEnrols() {
    // Merge person and enrolment records into one array so that we can access both readily.
    let preEnrols = this.model.map((person) => {
      let enrolment = null;
      if (!isEmpty(person.get('learner.enrolmentId'))) {
        enrolment = this.store.peekRecord(
          'people/enrolment',
          person.get('learner.enrolmentId'),
        );
      }
      return {
        person,
        enrolment,
      };
    });

    // Sort filtered results.
    if (this.sortDir === 'desc') {
      return preEnrols.sort(byKeys(this.sortProp)).reverse();
    } else {
      return preEnrols.sort(byKeys(this.sortProp));
    }
  }

  @action
  onChangeSort({ sortProp, sortDir }) {
    this.sortProp = sortProp;
    this.sortDir = sortDir;
  }
}
